<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { supplierService } from "../../services";
import SupplierDetails from "./supplier-details";
import { debounce,success_message,error_message } from "../../Helper/helper";

export default {
  components: { Layout, PageHeader, pagination,SupplierDetails},
    data() {
        const { status,orderBy,sortBy} = this.$route.query;
        return {
            title: this.trans.get('__JSON__.Supplier'),
            url: null,
            debounce: false,
            items: [],
            checked: true,
            sortBy: sortBy || "id",
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            paginations: {},
            limit: 1,
            search: "",
            status: status == undefined ? '1' :status,
            config: config,
            brandCount: "",
            showModal: false,
            supplierData: [],
            // searchData:debounce(()=>{
            //     if(!this.init){
            //         const {status,orderBy,sortBy} = this.$data;
            //         this.$router.replace({name: 'supplier-list', query: {status,orderBy,sortBy}})
            //     }
            //     this.getSupllier();
            //     this.init = false;
            // },500),
            
            fields: [
                { key: "id", label: "#", sortable: true },
                { key: "product_name", label: "Product Name", sortable: true },
                { key: "supplier", label: "Supplier", sortable: true },
                { key: "purchasing_price", label: "Purchasing Price", sortable: true },
                { key: "tax", label: "Tax", sortable: true },
            ],
        };
    },
    mounted() {
        this.getProducerCompany();
        this.asyncFindProduct({search:""});
    },
    methods: {
        asyncFindProduct(query) {
        	this.isLoading = true;
            supplierService
                .getAllProductByNameApi({ query })
                .then((response) => {
                this.products = response.data.result;
            	this.isLoading = false;
        	});
    	},
        showSupplierDetails(id){
            supplierService
            .getSupplierById({ id: id }).then((response) => {
                this.supplierData = response.data.result;
                this.showModal = true;
            });
        },
      async getProducerCompany() {
        this.loading = true;
        await supplierService
            .getProducerCompany()
            .then((response) => {
                this.loading = false;
                this.producer_company = response.data.result;

                // Find the matching company
                const matchingCompany = this.producer_company.find(company => company.id === this.supplierData.producer_company_id);
                
                // Do something with the matching company, e.g., set it to a data property
                if (matchingCompany) {
                  this.items.producer_company = matchingCompany;
                }
            });
      },
    },
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left">
                        <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                            <i class="bx bx-user-circle"></i>
                        </span>
                        </div>
                        <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Supplier') }}</h4>
                    </div>
                    <div class="page-title-right d-flex">
                        <router-link :to="{name: 'supplier-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
                            <i class="mdi mdi-plus mr-1"></i>
                            {{ trans.get('__JSON__.Add Supplier') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row list-table-main">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2 offset-sm-8">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                                        <!-- <select class="custom-select" v-model="status" @change="searchData()">
                                        <option value="">{{ trans.get('__JSON__.All') }}</option>
                                        <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                                        <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                                        </select> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="date-range-list">
                                    <label>{{ trans.get('__JSON__.Search') }} :</label>
                                    <div class="text-sm-right">
                                        <div class="search-box mr-2 d-inline-block">
                                            <div class="position-relative">
                                                <input
                                                type="text"
                                                class="form-control"
                                                id="search"
                                                v-model="search"
                                                :placeholder="trans.get('__JSON__.Search Placeholder')"
                                                />
                                                <i class="bx bx-search-alt search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 table-main-list customer-table table-responsive">
                                <h5>Pickup Orders</h5>
                                <table class="table supplier">
                                    <thead>
                                    <th>
                                        Product Name - Quntity x Botle size (Barcode)
                                    </th>
                                    <th>
                                        Quntity x Botle size
                                    </th>
                                    <th>
                                        Purchase Price without tax
                                    </th>
                                    <th>
                                        Purchase Price with tax
                                    </th>
                                    </thead>
                                    <tbody>
                                    <!-- <tr v-for="subProduct in $props.supplierdata.supplier_subProduct">
                                        <td v-for="product in products" v-if="product.sub_product_id === subProduct.sub_product_id">
                                        {{ product.product_name }} ( EAN: {{product.barcode_number }})
                                        </td>
                                        <td v-for="product in products" v-if="product.sub_product_id === subProduct.sub_product_id">
                                        {{ product.selling_qty }} x {{ product.att_name }}
                                        </td>
                                        <td>
                                        {{ subProduct.price_excluding_tax }}
                                        </td>
                                        <td>
                                        {{ subProduct.price_including_tax }}
                                        </td>
                                        
                                    </tr> -->
                                    </tbody>
                                </table>

                            </div>
                            <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                        <pagination
                                            :data="paginations"
                                            :limit="limit"
                                          
                                        ></pagination>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>